// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JLSt","col":"styles_col__cmgVS"};